import React from 'react';
import { SyncLiner24 } from 'seagull/icons';
import { QboIcon } from "./QboIcon";
import { ReconciledIcon } from "./ReconciledIcon";
export const qboIconMap = {
  pending: /*#__PURE__*/React.createElement(QboIcon, {
    intent: "pending"
  }),
  error: /*#__PURE__*/React.createElement(QboIcon, {
    intent: "error"
  }),
  success: /*#__PURE__*/React.createElement(QboIcon, {
    intent: "success"
  }),
  syncing: /*#__PURE__*/React.createElement(SyncLiner24, null),
  done: /*#__PURE__*/React.createElement(ReconciledIcon, null)
};